import * as React from 'react';
import styled, { css } from 'styled-components';
import { IRadioGroupProps } from '../radio-group-props';
import { selectThemeSemantics } from '../../../styling';

const requiredStyle = css`
    &:after {
        content: "*";
        color: ${selectThemeSemantics(({ palette }) => palette.red)};
    }
`;

const TitleContainer = styled.legend.attrs(() => ({
    className: String('ap-radioGroup-titleContainer')
})) <Pick<IRadioGroupProps, 'required'>>`
    padding: 0px 0px 10px 0px;
    ${({ required }) => (required ? requiredStyle : '')}
`;

export const Title = React.memo(({ groupLabel, required }: Required<Pick<IRadioGroupProps, 'groupLabel' | 'required'>>) => (groupLabel
    ? (
        <TitleContainer required={required} title={groupLabel}>
            {groupLabel}
        </TitleContainer>
    )
    : null));

Title.displayName = 'RadioGroupTitle';
